(function () {
  if (window.__pdpParametersUpdateReady) return;
  window.__pdpParametersUpdateReady = true;

  const EMPTY_VALUE = '—';
  const PARAM_ORDER = { brand: 1, collection: 2, volume: 3, size: 4, material: 5, weight: 6, sku: 7 };

  function getParametersLists() {
    const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
    const scope = section || document;
    const tabLists = Array.from(scope.querySelectorAll('.pdp-details-accordion-block .parameters-list, .pdp-details-accordion .parameters-list'));
    if (tabLists.length > 0) return tabLists;

    const fallback =
      scope.querySelector('accordion-custom.product-parameters .parameters-list') ||
      scope.querySelector('.parameters-list');
    return fallback ? [fallback] : [];
  }

  function getLabels(parametersList) {
    if (!parametersList) return {};
    return {
      size: parametersList.dataset.labelSize || 'Size',
      volume: parametersList.dataset.labelVolume || 'Capacity',
      material: parametersList.dataset.labelMaterial || 'Material',
      collection: parametersList.dataset.labelCollection || 'Collection',
      brand: parametersList.dataset.labelBrand || 'Brand',
      sku: parametersList.dataset.labelSku || 'SKU',
      weight: parametersList.dataset.labelWeight || 'Weight',
    };
  }

  function getEmptyValue(parametersList) {
    if (!parametersList) return EMPTY_VALUE;
    return parametersList.dataset.emptyValue || EMPTY_VALUE;
  }

  function normalizeParamValue(value) {
    if (value == null) return '';
    const trimmed = String(value).trim();
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return '';
    return trimmed;
  }

  function formatWeightDisplay(weightGrams) {
    const grams = Number(weightGrams);
    if (!Number.isFinite(grams) || grams <= 0) return '';

    if (grams < 1000) {
      return `${Math.round(grams)} g`;
    }

    const wholeKg = Math.floor(grams / 1000);
    const remG = grams % 1000;
    if (remG === 0) {
      return `${wholeKg} kg`;
    }

    const frac = String(remG).padStart(3, '0').replace(/0+$/, '');
    return `${wholeKg}.${frac} kg`;
  }

  function resolveWeightDisplay(variant) {
    if (!variant) return '';
    if (variant.weight_grams != null) {
      return formatWeightDisplay(variant.weight_grams);
    }
    return normalizeParamValue(variant.weight_display);
  }

  function displayParamValue(value, parametersList) {
    const normalized = normalizeParamValue(value);
    return normalized || getEmptyValue(parametersList);
  }

  function getSelectedSize() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const variantPicker = section ? section.querySelector('variant-picker') : document.querySelector('variant-picker');

      if (variantPicker) {
        const sizeOptions = variantPicker.querySelectorAll(
          '[data-option="Size"], [data-option="size"], [data-option="Размер"], [data-option="размер"]'
        );

        for (const option of sizeOptions) {
          if (option.matches('input:checked, option:selected, .selected, [aria-selected="true"]')) {
            const size = option.dataset.value || option.dataset.optionValue || option.textContent?.trim();
            if (size) return size;
          }
        }

        const selectElements = variantPicker.querySelectorAll('select');
        for (const select of selectElements) {
          const selectName = select.name?.toLowerCase() || '';
          const selectLabel = select.previousElementSibling?.textContent?.toLowerCase() || '';

          if (
            selectName.includes('size') ||
            selectName.includes('размер') ||
            selectLabel.includes('size') ||
            selectLabel.includes('размер')
          ) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
              const size =
                selectedOption.dataset.value || selectedOption.dataset.optionValue || selectedOption.textContent?.trim();
              if (size) return size;
            }
          }
        }

        const radioButtons = variantPicker.querySelectorAll('input[type="radio"]');
        for (const radio of radioButtons) {
          const radioName = radio.name?.toLowerCase() || '';
          const radioLabel = radio.closest('label')?.textContent?.toLowerCase() || '';

          if (
            (radioName.includes('size') || radioName.includes('размер') || radioLabel.includes('size') || radioLabel.includes('размер')) &&
            radio.checked
          ) {
            const size = radio.dataset.value || radio.dataset.optionValue || radio.value;
            if (size) return size;
          }
        }

        const variantsEl = document.querySelector('[data-variants]');
        if (variantsEl) {
          const variants = JSON.parse(variantsEl.textContent || '[]');
          const sizes = [...new Set(variants.map((v) => v.size).filter(Boolean))];
          if (sizes.length === 1) return sizes[0];
        }
      }

      return null;
    } catch {
      return null;
    }
  }

  function getProductMetafields() {
    try {
      const section = document.querySelector('[data-variants]')?.closest('.shopify-section');
      const productMetafields = {
        size: section?.querySelector('[data-product-size]')?.value?.trim() || '',
        material: section?.querySelector('[data-product-material]')?.value?.trim() || '',
        brand: section?.querySelector('[data-product-brand]')?.value?.trim() || '',
        category: section?.querySelector('[data-product-category]')?.value?.trim() || '',
      };

      const hiddenFields = section?.querySelectorAll('input[type="hidden"]');
      if (hiddenFields) {
        for (const field of hiddenFields) {
          const value = field.value ? field.value.trim() : '';
          if (value && value !== 'null' && value !== 'undefined') {
            if (field.name === 'product_size') productMetafields.size = value;
            if (field.name === 'product_material') productMetafields.material = value;
            if (field.name === 'product_brand') productMetafields.brand = value;
            if (field.name === 'product_category') productMetafields.category = value;
          }
        }
      }

      return productMetafields;
    } catch {
      return {};
    }
  }

  function updateVolumeParam(parametersList, value) {
    if (!parametersList) return;

    const normalized = normalizeParamValue(value);
    const item = parametersList.querySelector('.parameter-item[data-param="volume"]');

    if (!normalized) {
      if (item) item.remove();
      return;
    }

    if (!item) {
      const labels = getLabels(parametersList);
      const newItem = document.createElement('div');
      newItem.className = 'parameter-item';
      newItem.setAttribute('data-param', 'volume');
      newItem.innerHTML =
        '<span class="parameter-label">' +
        (labels.volume || 'Capacity') +
        '</span><span class="parameter-value">' +
        normalized +
        '</span>';
      newItem.style.order = String(PARAM_ORDER.volume || 3);
      parametersList.appendChild(newItem);
      return;
    }

    const valueEl = item.querySelector('.parameter-value');
    if (valueEl) valueEl.textContent = normalized;
  }

  function createParameterIfNotExists(paramName, value, parametersList) {
    if (!parametersList) return;
    if (paramName === 'volume') return;

    const found = !!parametersList.querySelector('.parameter-item[data-param="' + paramName + '"]');
    if (found) return;

    const labels = getLabels(parametersList);
    const newItem = document.createElement('div');
    newItem.className = 'parameter-item';
    if (paramName === 'sku') newItem.classList.add('parameter-item--sku');
    newItem.setAttribute('data-param', paramName);
    newItem.innerHTML =
      '<span class="parameter-label">' +
      (labels[paramName] || paramName) +
      '</span><span class="parameter-value">' +
      displayParamValue(value, parametersList) +
      '</span>';

    newItem.style.order = String(PARAM_ORDER[paramName] || 99);
    parametersList.appendChild(newItem);
  }

  function updateParameters(variantId) {
    try {
      const variantsEl = document.querySelector('[data-variants]');
      if (!variantsEl) return;

      const variants = JSON.parse(variantsEl.textContent || '[]');
      const variant = variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const parametersLists = getParametersLists();
      if (parametersLists.length === 0) return;

      parametersLists.forEach((parametersList) => {
        const updateParam = (paramName, value) => {
          const item = parametersList.querySelector('.parameter-item[data-param="' + paramName + '"]');
          if (!item) return;

          const valueEl = item.querySelector('.parameter-value');
          if (!valueEl) return;

          const displayValue = normalizeParamValue(value) || getEmptyValue(parametersList);
          const link = valueEl.querySelector('.collection-link');
          if (link) {
            link.textContent = displayValue;
            return;
          }

          valueEl.textContent = displayValue;
        };

        const selectedSize = getSelectedSize();
        const productMetafields = getProductMetafields();

        let sizeValue = '';
        if (variant.size && variant.size !== null && String(variant.size).trim() !== '' && variant.size !== '0') {
          sizeValue = variant.size;
        } else if (selectedSize && selectedSize !== '0') {
          sizeValue = selectedSize;
        } else if (
          productMetafields.size &&
          productMetafields.size !== '3' &&
          productMetafields.size !== '0' &&
          productMetafields.size.trim() !== ''
        ) {
          sizeValue = productMetafields.size;
        }

        const materialValue =
          variant.material && variant.material !== null && String(variant.material).trim() !== ''
            ? variant.material
            : productMetafields.material || '';
        const brandValue =
          variant.brand && variant.brand !== null && String(variant.brand).trim() !== ''
            ? variant.brand
            : productMetafields.brand || '';
        const skuValue = normalizeParamValue(variant.sku);
        const weightValue = resolveWeightDisplay(variant);
        const volumeValue = normalizeParamValue(variant.volume);

        updateVolumeParam(parametersList, volumeValue);
        updateParam('size', sizeValue);
        updateParam('material', materialValue);
        updateParam('brand', brandValue);
        updateParam('sku', skuValue);
        updateParam('weight', weightValue);

        createParameterIfNotExists('size', sizeValue, parametersList);
        createParameterIfNotExists('material', materialValue, parametersList);
        createParameterIfNotExists('brand', brandValue, parametersList);
        createParameterIfNotExists('sku', skuValue, parametersList);
        createParameterIfNotExists('weight', weightValue, parametersList);
      });
    } catch (error) {
      console.error('Error updating parameters:', error);
    }
  }

  function bindDescriptionScrollToParameters() {
    document.querySelectorAll('[data-pdp-scroll-parameters]').forEach((button) => {
      if (button.dataset.pdpScrollBound === 'true') return;
      button.dataset.pdpScrollBound = 'true';

      button.addEventListener('click', () => {
        const scope = button.closest('.product-information') || button.closest('.shopify-section') || document;
        const target = scope.querySelector('[data-pdp-accordion-parameters]');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    document.addEventListener('variant:changed', (event) => {
      if (event.detail?.variant) updateParameters(event.detail.variant.id);
    });

    document.addEventListener('variant:update', (event) => {
      if (event.detail?.resource) updateParameters(event.detail.resource.id);
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('variant-picker')) {
        const variantId = event.target.dataset.variantId || event.target.value;
        if (variantId) updateParameters(variantId);
      }
    });

    window.addEventListener('popstate', () => {
      const urlMatch = window.location.href.match(/\/variants\/(\d+)/);
      if (urlMatch) {
        updateParameters(urlMatch[1]);
        return;
      }

      const variantId = new URLSearchParams(window.location.search).get('variant');
      if (variantId) updateParameters(variantId);
    });

    const currentVariantId =
      new URLSearchParams(window.location.search).get('variant') || document.querySelector('input[name="id"]')?.value;

    if (currentVariantId) {
      updateParameters(currentVariantId);
    } else {
      setTimeout(() => {
        const variantsEl = document.querySelector('[data-variants]');
        if (!variantsEl) return;
        const variants = JSON.parse(variantsEl.textContent || '[]');
        if (variants.length > 0) updateParameters(variants[0].id);
      }, 1000);
    }

    bindDescriptionScrollToParameters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
